
import React from "react";
import { CreditCard } from "lucide-react";
import { PaymentMethod } from "./types";

interface PaymentMethodsListProps {
  paymentMethods: PaymentMethod[];
  onSelectPaymentMethod: (methodId: string) => void;
  isProcessing: boolean;
  userCountry: string;
}

export const PaymentMethodsList: React.FC<PaymentMethodsListProps> = ({
  paymentMethods,
  onSelectPaymentMethod,
  isProcessing,
  userCountry
}) => {
  const renderIcon = (icon: PaymentMethod['icon']) => {
    if (icon.type === "lucide" && icon.name === "CreditCard") {
      return <CreditCard {...icon.props} />;
    } else if (icon.type === "image" && icon.src) {
      return <img src={icon.src} alt={icon.alt || ""} {...icon.props} />;
    }
    return null;
  };

  return (
    <div className="space-y-4 py-4">
      {paymentMethods.map((method) => (
        <div 
          key={method.id}
          className={`flex items-center gap-4 p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors ${isProcessing ? 'opacity-50 pointer-events-none' : ''}`}
          onClick={() => !isProcessing && onSelectPaymentMethod(method.id)}
        >
          <div className="flex-shrink-0 w-10 flex items-center justify-center">
            {renderIcon(method.icon)}
          </div>
          <div>
            <h3 className="font-medium">{method.name}</h3>
            <p className="text-sm text-muted-foreground">{method.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
